"use client";

import faq_data from "@/data/FaqData";
import { useState } from "react";

const FaqArea = () => {
  const [activeId, setActiveId] = useState<number | null>(0);

  return (
    <div className="pt-140 pb-140 overflow-hidden position-relative z-index-common">
      <div className="faq-2-shape-1"></div>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-6 text-center">
            <div className="section-title mb-50">
              <span className="sub-title">FAQ</span>
              <h2 className="title style2">
                Popular questions about BitPrimax
              </h2>
              <p className="sec-text">
                Find answers to common questions about our platform, security,
                trading, and more to help you get started with confidence.
              </p>
            </div>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="accordion-area accordion" id="faqAccordion">
              {faq_data
                .filter((items) => items.page === "home_2")
                .map((item) => (
                  <div key={item.id} className="accordion-card style2">
                    <div
                      className="accordion-header"
                      id={`collapse-item-${item.id}`}
                    >
                      <button
                        className={`accordion-button ${
                          item.id === activeId ? "" : "collapsed"
                        }`}
                        type="button"
                        onClick={() =>
                          setActiveId((prev) =>
                            prev === item.id ? null : item.id
                          )
                        }
                        // data-bs-toggle="collapse"
                        // data-bs-target={`#collapse-${item.id}`}
                        // aria-expanded="true"
                        // aria-controls={`collapse-${item.id}`}
                      >
                        {item.title}
                      </button>
                    </div>
                    <div
                      // id={`collapse-${item.id}`}
                      className={`accordion-collapse ${
                        item.id === activeId ? "show" : "collapse"
                      }`}
                      aria-labelledby={`collapse-item-${item.id}`}
                      data-bs-parent="#faqAccordion"
                    >
                      <div className="accordion-body">
                        <p className="faq-text">{item.desc}</p>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FaqArea;
